import {
  TDS_REPORT_REQUEST,
  TDS_REPORT_SUCCESS,
  TDS_REPORT_FAILURE
} from "../types/tds-report-types";

const initialState = {
  tdsReport: {},
  loading: false,
  error: null,
};

const tdsReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case TDS_REPORT_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      };
    }
    case TDS_REPORT_SUCCESS: {
      return {
        ...state,
        tdsReport: {...(action.payload || {})},
        loading: false,
        error: null
      };
    }
    case TDS_REPORT_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      };
    }
    default:
      return state;
  }
};

export default tdsReportReducer;
